import { theme } from '@styles/theme';

export const CARD = {
  bgcolor: 'white',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '16px',
  p: '26px',
};

export const TITLE = { fontSize: 15, fontWeight: 700, color: theme.palette.grey[900] };

export const LABEL = {
  fontSize: 13,
  fontWeight: 600,
  color: theme.palette.grey[600],
  display: 'block',
  mb: '7px',
};

export const FIELD: object = {
  '& .MuiOutlinedInput-root': {
    height: 44,
    borderRadius: '10px',
    fontSize: 14,
    color: theme.palette.grey[900],
    '& fieldset': { borderColor: theme.palette.grey[200] },
    '&:hover fieldset': { borderColor: theme.palette.grey[400] },
    '&.Mui-focused fieldset': { borderColor: theme.palette.primary.main, borderWidth: 1 },
  },
};

export const FIELD_DISABLED: object = {
  '& .MuiOutlinedInput-root': {
    height: 44,
    borderRadius: '10px',
    fontSize: 14,
    color: theme.palette.grey[400],
    bgcolor: theme.palette.grey[100],
    '& fieldset': { borderColor: theme.palette.grey[200] },
  },
};

export const SAVE_BTN = {
  bgcolor: theme.palette.primary.main,
  borderRadius: '8px',
  color: 'white',
  fontSize: 13,
  fontWeight: 600,
  textTransform: 'none' as const,
  px: '18px',
  py: '9px',
  boxShadow: 'none',
  '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 'none' },
};

export const PENCIL_BTN = {
  width: 34,
  height: 34,
  borderRadius: '8px',
  color: theme.palette.grey[500],
  '&:hover': { bgcolor: theme.palette.grey[100] },
};

export const CANCEL_BTN = {
  borderRadius: '8px',
  color: theme.palette.grey[700],
  fontSize: 13,
  fontWeight: 600,
  textTransform: 'none' as const,
  px: '18px',
  py: '9px',
  border: `1px solid ${theme.palette.grey[200]}`,
  '&:hover': { bgcolor: theme.palette.grey[50], borderColor: theme.palette.grey[300] },
};
